// import api from '🔗/api';
import moment from 'moment';
import { TRACKS_STATES } from '🔗/constants';
import stores from '@/stores';


export const TRACKS_FILTERS = [
    {
        code: "createdAt",
        type: "date",
        range: true,
        name: 'filter.default.created-date',
        formatter: (values) => {
            if (values?.length !== 2) {
                return {};
            }
            return {
                createdAt_lte: moment(values[1]).toISOString(),
                createdAt_gte: moment(values[0]).toISOString()
            };
        }
    //     code: "name",
    //     type: "string",
    //     name: 'filter.artists.default.name'
    }, {
        code: "release_date",
        type: "date",
        range: true,
        name: 'filter.tracks.default.release_date',
        formatter: (values) => {
        	if (values?.length !== 2) {
        		return {};
        	}
        	return {
                releaseDate_lte: moment(values[1]).toISOString(),
        		releaseDate_gte: moment(values[0]).toISOString()
        	};
        }
    }, {
        code: "state",
        type: "autocomplete",
        multiple: false,
        name: 'filter.default.state',
        useI18n: true,
        options: [],
        onSearch: async (searchStr) => {
            const t = stores.locale().t();
            const str = searchStr?.trim().toLowerCase();

            if (!str) {
                return TRACKS_STATES;
            }
            return TRACKS_STATES.filter(item => t(item.name).toLowerCase().indexOf(str) !== -1);
        }
    }, {
        code: "contributors",
        type: "autocomplete",
        multiple: true,
        name: 'filter.tracks.default.contributors',
        options: [],
        onSearch: async (searchStr) => {
            const params = {
                skip: 0,
                take: 20,
                sort: 'name',
                sort_dir: 'asc'
            }

            if (searchStr?.trim()) {
                params.title = searchStr.trim().toLowerCase();
            }

            const payload = await api.artists().list(params);

            if (!payload?.items) {
                return [];
            }

            return payload.items.map(item => ({ code: item.id, name: item.name }));
        }
    }
]
